{
  "connection": {
    "welcomeMessage": "Välkommen, {{firstName}}!",
    "description": "Konfigurera Chirpee på 15 minuter och börja samla in feedback från dina medarbetare i realtid.",
    "pill": {
      "setupNow": "Konfigurera nu",
      "connected": "Ansluten",
      "completed": "Slutförd"
    },
    "options": {
      "ssoConnected": {
        "title": "Anslut SSO",
        "description": "Ställ in Single Sign-On för att hantera åtkomst för din organisation.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Hantera"
      },
      "hrisConnected": {
        "title": "Anslut organisationsschema",
        "description": "Importera din organisationsstruktur för automatiserade arbetsflöden.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      },
      "messagingConnected": {
        "title": "Anslut kommunikationsverktyg",
        "description": "Samla in feedback via teamets kommunikationsplattformar.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      },
      "billingSetup": {
        "title": "Ställ in fakturering",
        "description": "Lägg till din betalningsinformation och välj en passande plan.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      },
      "branding": {
        "title": "Företagsprofil",
        "description": "Anpassa företagets profil för en enhetlig upplevelse.",
        "tooltipTitle": "Hjälptext",
        "buttonLabel": "Konfigurera"
      }
    }
  },
  "billing": {
    "backToGettingStarted": "Tillbaka till Kom igång",
    "title": "Ställ in fakturering",
    "description": "Välj det faktureringsalternativ som passar din organisation bäst.",
    "currencyLabel": "Valuta:",
    "currencyPlaceholder": "Valuta",
    "taxDisclaimer": "Alla priser exkluderar tillämpliga skatter.",
    "freeTrial": {
      "title": "Börja med en 30 dagars gratis provperiod",
      "description": "Ingen debitering förrän provperioden är slut. Samla in din första månad med medarbetarinsikter helt gratis."
    },
    "employeeCount": {
      "title": "Antal medarbetare",
      "hrisConnected": "HRIS anslutet",
      "pendingHrisSync": "Väntar på HRIS-synk",
      "readonlyCount": "{{count}} medarbetare",
      "description": "Antalet medarbetarplatser är dynamiskt och baseras på antalet aktiva användare som synkroniseras från ditt HRIS-system och får frågor."
    },
    "plans": {
      "recommended": "Rekommenderad",
      "perEmployeeMonth": "per medarbetare / månad",
      "employeeCountFormula": "{{count}} medarbetare",
      "monthlyTotal": "Månadssumma",
      "perMonth": "/ månad",
      "launchingCheckout": "Startar checkout...",
      "monthly": {
        "title": "Månadsplan",
        "subtitle": "Faktureras månadsvis",
        "cta": "Välj månadsplan"
      },
      "annual": {
        "title": "Årsplan",
        "subtitle": "Faktureras årligen",
        "cta": "Välj årsplan",
        "savingsBadge": "Spara {{percent}} %",
        "savingsText": "Spara {{amount}}/år med {{count}} medarbetare"
      }
    },
    "features": {
      "title": "Alla funktioner ingår i båda planerna",
      "comingSoon": "Kommer snart",
      "items": {
        "dailyQuestionDelivery": "Daglig frågeleverans",
        "enterpriseSecurity": "Säkerhet i enterprise-klass",
        "slackTeamsIntegration": "Slack- och Teams-integration",
        "analyticsDashboard": "Komplett analysdashboard",
        "teamInsights": "Obegränsade teaminsikter",
        "hrisIntegration": "HRIS-integration",
        "dedicatedSupport": "Dedikerad support",
        "surveyBuilder": "Enkätbyggare"
      }
    },
    "socialProof": {
      "title": "Varför organisationer väljer kontinuerlig feedback",
      "cards": {
        "turnover": {
          "description": "Lägre personalomsättning i organisationer med regelbunden feedback",
          "source": "Gallup, 2023"
        },
        "managerEffectiveness": {
          "description": "Högre chefseffektivitet med kontinuerliga medarbetarinsikter",
          "source": "Harvard Business Review, 2022"
        },
        "profitMargins": {
          "description": "Högre vinstmarginaler i företag som använder kontinuerliga feedbacksystem",
          "source": "PwC, 2023"
        }
      }
    },
    "invoiceFooter": "Behöver du fakturabaserad betalning? Kontakta oss på <supportLink>support@chirpee.co</supportLink>",
    "complete": {
      "title": "Betalningsinställning",
      "description": "Din betalningsinställning bekräftas. Gå tillbaka till Kom igång för att fortsätta onboarding."
    },
    "errors": {
      "chooseCurrency": "Välj en faktureringsvaluta innan du fortsätter.",
      "stripeKeyMissing": "Stripes publicerbara nyckel är inte konfigurerad.",
      "checkoutStartFailed": "Det gick inte att starta checkout. Försök igen.",
      "setupLoadFailed": "Vi kunde inte läsa in detaljerna för faktureringsinställningen.",
      "retry": "Försök igen",
      "pricingUnavailable": "Priser är inte tillgängliga för {{currency}}. Välj en annan valuta."
    }
  }
}
